import {
    IRIS_PERSONALIZED_CONTENT_SUCCESS,
    IRIS_PERSONALIZED_CONTENT_ERROR,
} from '../actionTypes/PersonalizedContentServiceActionTypes';

function PersonalizedContentServiceReducer(state = {}, action = {}) {
    switch (action.type) {
        case IRIS_PERSONALIZED_CONTENT_ERROR:
        case IRIS_PERSONALIZED_CONTENT_SUCCESS:
            const { response } = action;

            return { ...state, ...response };

        default:
            return state;
    }
}

PersonalizedContentServiceReducer.reducerName = 'personalizedContentService';
export default PersonalizedContentServiceReducer;
